class DrupalParser {

  constructor(result, fields, includes) {
    this.result = result;
    this.fields = fields;
    this.includes = includes;
  }

  parse() {
    let parsedResults = [];
    this.result.data.map(
      (item) => {
        parsedResults.push(this.parseItem(item))
      }
    );
    parsedResults = this.parsePaging(parsedResults);
    return parsedResults;
  }

  parsePaging(parsedResults) {
    if (this.result.links) {
      parsedResults.paging = {};
      if (this.result.links.next) {
        parsedResults.paging.next = this.result.links.next;
      }
      if (this.result.links.prev) {
        parsedResults.paging.prev = this.result.links.prev;
      }
      if (this.result.links.self) {
        parsedResults.paging.self = this.result.links.self;
      }
    }

    return parsedResults;
  }

  parseItem(item) {
    let returnObject = {};
    returnObject = this.parseIncludes(returnObject, item);
    returnObject = this.parseSimpleFields(returnObject, item);
    return returnObject;
  }

  /*
    ToDo: Make this recursive and unaware of this.fields (so we can use it recursively for i.e. Taxonomy terms in include
    Parses simple fields
    1. Checks if it's not included
    2. If not included check if item has field
    3. If not included in field, check if it's in attributes
   */
  parseSimpleFields(parsedObject, item){
    let includes = this.includes.split(',');
    Object.keys(this.fields).forEach(nodeType => {
      let fields = this.fields[nodeType].split(',');
      fields.map(field => {
        if (!includes[field]) {
          if (item[field]) {
            parsedObject[field] = item[field];
          } else if(item.attributes[field]) {
            parsedObject[field] = item.attributes[field];
          }
        }
      });
    });

    return parsedObject;
  }

  /*
    Parses includes, which are relationships of the item
   */
  parseIncludes(parsedObject, item) {
    let includes = this.includes.split(',');
    if (includes.length === 0) {
      return parsedObject;
    }
    includes.map((include) => {
      if (item.relationships[include] !== undefined && item.relationships[include].data) {
        let relationship_id = 0;

        // If data is an array, set array to parsed Obh
        if (Array.isArray(item.relationships[include].data)) {
          item.relationships[include].data.map((include_item) => {
            relationship_id = include_item.id;

            if (typeof parsedObject[include] === 'undefined') {
              parsedObject[include] = [];
            }
            let found_id = this.result.included.find(relation => {
              return relation.id === relationship_id;
            });
            parsedObject[include].push(found_id);
          });

        } else {
          relationship_id = item.relationships[include].data.id;
          // ToDo: Parse the found result
          parsedObject[include] = this.result.included.find(relation => {
            return relation.id === relationship_id;
          });
        }


      }
    });
    return parsedObject;
  }

}

export default DrupalParser;
